module.exports = __webpack_public_path__ + "img/error.d1b0f566.png";